export const TabTitles = {
    OVERVIEW: 'Overview',
    ELIGIBILITY: 'Eligibility',
    FUNDING: 'Funding',
    CHANGELOG: 'Changelog',
} as const;
